module.exports = {"654225100":"哈拉布拉镇","654225101":"吉也克镇","654225200":"哈拉布拉乡","654225201":"新地乡","654225202":"阿勒腾也木勒乡","654225204":"江格斯乡","654225400":"察汗托海牧场","654225501":"兵团农九师一六一团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654225.json
// module id = 3141
// module chunks = 0